import { FeatureFlagEnum } from '../featureflag/feature-flag.enum';
import { useGetProductColorsSelloutTotals } from '../services/modules/product-color-sellout/product-color-sellout.queries';
import { SelloutSummary } from '../services/modules/product-color-sellout/product-color-sellout.types';
import { getSelloutSummaryFromQuantity } from '../services/modules/product-color-sellout/productColorSellout.utils';
import useSystemParametersStore from '../stores/SystemParameters/useSystemParameters.store';
import { UseProductColorsSelloutSummaryParams } from './useProductColorsSelloutSummary.types';

export const useProductColorsSelloutSummary = ({
  productColorIds,
  orderId,
  enabled = true,
  isSummaryPreservedWhileFetching = false,
}: UseProductColorsSelloutSummaryParams) => {
  const { getBrandSystemParameterValue } = useSystemParametersStore();
  const minValue = getBrandSystemParameterValue<number>(
    FeatureFlagEnum.COMMERCE_MIN_VALUE_TO_SHOW_SELLOUT_TAG,
  );

  const selloutTotals = useGetProductColorsSelloutTotals(
    { productColorIds, orderId },
    { enabled: enabled && (!productColorIds || productColorIds.length > 0) },
  );

  const quantityByProductColorId = new Map(
    (selloutTotals.data ?? []).map((total) => [total.productColorId, total.totalQuantitySold]),
  );

  const getSummary = (productColorId: string): SelloutSummary =>
    getSelloutSummaryFromQuantity({
      isFetching: isSummaryPreservedWhileFetching ? false : selloutTotals.isFetching,
      quantitySold: quantityByProductColorId.get(productColorId),
      minValue,
    });

  return {
    getSummary,
    isFetching: selloutTotals.isFetching,
    refetch: selloutTotals.refetch,
  };
};
